import { cubicEaseOut } from '@helpers/animate';
import brand from '@helpers/brand';
import fonts from '@helpers/fonts';
import { Layers } from '@helpers/layers';
import styled from 'styled-components';
import { Device, from } from '@helpers/media';
const Container = styled.nav `
  --bgColor: ${brand.white};

  position: fixed;
  top: var(--headerContainerHeight);
  left: 0;
  display: flex;
  flex-direction: column;
  background: var(--bgColor);
  height: calc(100% - var(--headerContainerHeight));
  opacity: 0;
  overflow-y: auto;
  padding: 0;
  pointer-events: none;
  transition: opacity 0.15s ${cubicEaseOut};
  width: 100%;
  z-index: ${Layers.Header};

  &[data-m-active='true'] {
    opacity: 1;
    pointer-events: all;
  }

  @media ${from(Device.TabletLarge)} {
    display: none;
  }
`;
const Item = styled.li `
  display: flex;
  width: 100%;
  position: relative;
`;
const ChevronLink = styled.a `
  padding: 16px;
  flex: 0 0 56px;
  position: absolute;
  right:0;
  height: 60px;

  &:focus,
  &:hover {
    outline: none;
  }
`;
const Link = styled.a `
  display: flex;
  align-items: center;
  color: ${brand.new.darkgrey};
  ${fonts.helvetica.regular};
  font-size: 18px;
  line-height: 28px;
  padding: 16px 0 16px 20px;
  text-decoration: none;
  border: none;
  outline: none;
  border-bottom: 1px solid ${brand.new.midblue};
  transition: all 0.1s ${cubicEaseOut};
  width: 100%;
 
  li:has(> [data-active='true']) & {
    background: ${brand.yellow.base};
  }
`;
const Text = styled.span `
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex: 0 0 auto;
  
  li:has(> ${ChevronLink}) & {
    flex: 0 0 calc(100% - 66px);
    max-width: calc(100% - 66px); 
  }
`;
const List = styled.ul `
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;

  &[data-active='true'] ${Link}{
      border-left: 10px solid ${brand.yellow.base};
   background:${brand.white};
  }

`;
const SubList = styled.ul `
  overflow: hidden;
  transition: all 0.6s ${cubicEaseOut};
  max-height: 0;
  width:100%;
  
  &[data-active='true'] {
    max-height: 600px; 
  }

  ${Link}[data-active='true'] {
    border-left: 10px solid ${brand.yellow.base};
    background: var(--bgColor);
  }

  &[data-active='true'] ${Link} {
    background-color: ${brand.new.cream};
    border-left: 10px solid ${brand.blue.blue5};
  }
`;
const MobileNavigationStyles = {
    Container,
    ChevronLink,
    Item,
    Link,
    List,
    Text,
    SubList
};
export default MobileNavigationStyles;
